export default __webpack_public_path__ + "static/media/RoundedCheckIconGrey.405a3d7b.svg";